
export const checkLinkForRoute = (link, appRoute) => {
    if(appRoute && link.includes(appRoute)) {
        return { routeLink: link.replace(appRoute, "/"), useRoute: true}
    }

    return { routeLink: link, useRoute: false };
}